import { Monitor, Moon, Sun } from 'lucide-react';

import { RadioGroup } from './RadioGroup';
import { FARBSCHEMATA, type Farbschema } from '../../lib/farbschema';
import { cn } from '../../lib/utils';

/**
 * Hell, dunkel oder wie das Betriebssystem.
 *
 * Drei Zustaende statt eines Umschalters: Ein Schalter zwischen hell und dunkel
 * kann nicht ausdruecken, dass man es dem Geraet ueberlassen will - und genau
 * das ist die Voreinstellung.
 *
 * Auf `RadioGroup` aufgebaut, damit die Wahl mit den Pfeiltasten bedienbar ist
 * und ein Vorleseprogramm sie als Gruppe ansagt.
 */

const SYMBOLE: Record<Farbschema, typeof Monitor> = {
  system: Monitor,
  hell: Sun,
  dunkel: Moon,
};

interface Props {
  schema: Farbschema;
  onChange: (schema: Farbschema) => void;
  className?: string;
}

export const FarbschemaWahl: React.FC<Props> = ({ schema, onChange, className }) => (
  <RadioGroup<Farbschema>
    label="Farbschema"
    value={schema}
    onChange={onChange}
    options={FARBSCHEMATA.map((eintrag) => ({
      id: eintrag.id,
      label: eintrag.label,
      icon: SYMBOLE[eintrag.id],
    }))}
    className={cn('flex-nowrap gap-1 rounded-lg bg-slate-100 p-1', className)}
    optionClassName={(_option, aktiv) => cn(
      'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-semibold',
      aktiv ? 'bg-white text-brand-600 shadow-sm' : 'text-slate-500 hover:text-slate-800',
    )}
  />
);

export default FarbschemaWahl;
